import React from 'react';
import { Button, Grid, Typography } from '@mui/material';
import LoginSelect from '../LoginSelect/LoginSelect';

const ForgetForm = ({
    phoneValue,
    phoneError,
    country,
    countryError,
    handleChangePhoneValue,
    handleForgetPassword,
}) => {
    return (
        <Grid width="100%" mt="30px" bgcolor="white" p={{ xs: '30px 15px', sm: '30px' }} borderRadius="8px">
            <Grid display="flex" alignItems="center" justifyContent="center" mb="50px">
                <Typography variant="h2" color="#FDA058" fontWeight={700}>
                    فراموشی رمز عبور
                </Typography>
            </Grid>
            <Grid mb="48px">
                <Grid display="flex" alignItems="center" flexDirection="row-reverse" gap="8px" width="100%">
                    <Grid width={{ xs: '50%', xxs: '70%' }}>
                        <form style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                            <label htmlFor="Phone" style={{ marginBottom: '4px', fontSize: '16px' }}>
                                تلفن
                            </label>
                            <input
                                type="number"
                                id="Phone"
                                name="Phone"
                                value={phoneValue}
                                onChange={handleChangePhoneValue}
                                style={{
                                    padding: '12px',
                                    color: '#3C3D37',
                                    borderRadius: '4px',
                                    outline: 'none',
                                    fontSize: '16px',
                                    height: '50px',
                                    border: '2px solid rgb(60, 61, 55)',
                                }}
                            />
                        </form>
                    </Grid>
                    <Grid width={{ xs: '50%', xxs: '30%' }} height="72px">
                        <LoginSelect options={country} />
                    </Grid>
                </Grid>
                {phoneError && (
                    <Typography variant="subtitle1" color="#B8001F" fontWeight={700}>
                        {phoneError}
                    </Typography>
                )}
                {countryError && (
                    <Typography mt="4px" variant="subtitle1" color="#B8001F" fontWeight={700}>
                        {countryError}
                    </Typography>
                )}
            </Grid>
            <Button
                onClick={handleForgetPassword}
                sx={{
                    bgcolor: '#FDA058',
                    borderRadius: '12px',
                    width: '100%',
                    p: '12px 0px',
                    color: 'white',
                    fontSize: '16px',
                    fontWeight: 700,
                    boxShadow: 5,
                    mb: '36px',
                    '&:hover': { bgcolor: '#FF8343' },
                }}
            >
                بازیابی رمز عبور
            </Button>
        </Grid>
    );
};

export default ForgetForm;
